<h2 mat-dialog-title>{{data.title | translate}}</h2>
<mat-dialog-content>{{data.subtitle | translate}}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{data.negativeText | translate}}</button>
  <button class="m-l-10" mat-flat-button color="primary" [mat-dialog-close]="true">{{data.positiveText | translate}}</button>
</mat-dialog-actions>

